export default __webpack_public_path__ + "static/media/deadboy_003.7178845f.jpg";